"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = hexToRgb;

function hexToRgb(color) {
  var hex = color.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return {
    r: r,
    g: g,
    b: b
  };
}